"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs_1 = __importDefault(require("fs"));
const proms_1 = require("./proms");
class FileLineWriter {
    constructor(filename, options) {
        var _a;
        if (!filename) {
            throw new Error('expecting filename');
        }
        this.proms = new proms_1.Proms({
            batchSize: (_a = options === null || options === void 0 ? void 0 : options.batchSize) !== null && _a !== void 0 ? _a : 100
        });
        this.ofs = fs_1.default.createWriteStream(filename);
    }
    write(entry) {
        const p = new Promise((resolve, reject) => {
            this.ofs.write(entry, (err) => {
                if (err)
                    return reject(err);
                return resolve();
            });
        });
        return this.proms.run(p);
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.proms.awaitproms();
            this.ofs.close();
        });
    }
}
exports.FileLineWriter = FileLineWriter;
//# sourceMappingURL=FileLineWriter.js.map